import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const POLL_MS = 15000;

// Module-scoped singleton so every component using the hook shares one
// background poller and the same latest value. Avoids N components each
// running their own 15s interval.
let cached = { ok: false, title: null, artist: null };
let timerStarted = false;
const subscribers = new Set();

function broadcast() {
  for (const cb of subscribers) cb(cached);
}

async function pollOnce() {
  try {
    const res = await axios.get(`${API}/now-playing`);
    cached = res?.data || { ok: false, title: null, artist: null };
  } catch (_) {
    // keep prior value on transient error
  }
  broadcast();
}

function ensureTimer() {
  if (timerStarted) return;
  timerStarted = true;
  pollOnce();
  setInterval(pollOnce, POLL_MS);
}

/**
 * useNowPlaying — returns { ok, title, artist } for the live Radiojar stream.
 * Updates roughly every 15 seconds. All callers share one underlying poller.
 */
export default function useNowPlaying() {
  const [value, setValue] = useState(cached);
  useEffect(() => {
    ensureTimer();
    subscribers.add(setValue);
    setValue(cached);
    return () => {
      subscribers.delete(setValue);
    };
  }, []);
  return value;
}
